import React, { FC } from 'react';

import { TEXTS } from 'application/pages/BillingPage/renderer/texts';
import CommonUtils from 'application/utils/CommonUtils';

import Text from '@zvuk-b2b/react-uikit/ui/Text';

import { AmountProps } from './types';

import styles from './index.module.scss';
import useAmountViewModel from './useAmountViewModel';

const Amount: FC<AmountProps> = ({ selectedPriceItemPeriodId, currentPeriodId }) => {
  const viewModel = useAmountViewModel({ selectedPriceItemPeriodId, currentPeriodId });

  if (!viewModel) {
    return (
      <Text
        elementId="title_subscription_cost_by_price_period_id"
        className={styles.amountSkeleton}
        isLoading
        as="div"
      />
    );
  }

  const { subscriptionCostByPricePlanPeriod, nextBillingAmount, licenseCostLoading, withDiscountAndCurrentSelected } =
    viewModel;

  return (
    <div className={styles.amount}>
      <Text
        elementId="title_subscription_cost_by_price_period_id"
        className={licenseCostLoading ? styles.amountSkeleton : styles.amount}
        isLoading={licenseCostLoading}
        as="div">
        {TEXTS.BILLING_LICENSES_AMOUNT(
          CommonUtils.numberWithSeparation(
            withDiscountAndCurrentSelected ? nextBillingAmount : subscriptionCostByPricePlanPeriod
          )
        )}
      </Text>
    </div>
  );
};

export default React.memo(Amount);
